import { SET_CLAIM_CODE } from './types';

const initialState = {
  claimCode: '',
};

export const claimCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CLAIM_CODE:
      return { ...state, claimCode: action.payload };
    default:
      return state;
  }
};
